'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var cx = require('classnames');
var Button = require('@arrive/button');
var SVGIcon = require('@arrive/svg-icon');
var CLOSE = require('@arrive/ui-icons/svg/ic_close.svg');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var SVGIcon__default = /*#__PURE__*/_interopDefaultLegacy(SVGIcon);
var CLOSE__default = /*#__PURE__*/_interopDefaultLegacy(CLOSE);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = {"ethanol":"#fff","tandem":"#f4f5f5","chrome":"#d4d6d9","LFGray":"#9ea2a9","smokey":"#60646c","burnout":"#46494f","roadhog":"#303236","axle":"#1d1e20","grease":"#0a0a0b","bandit":"#e0f3fb","bigSky":"#b1e1f5","arrive":"#2aaae2","blueBayou":"#039ddd","nightTime":"#007dbc","blueridge":"#0062c0","gasoline":"#feefcb","diesel":"#f1ae11","mileMarker":"#e8f5e9","gatorguts":"#4caf50","frogger":"#2b731a","whoaNelly":"#ffedf1","jackknife":"#cb2024","applyButtonBar":"arrive_ApplyButtonBar__applyButtonBar","defaultControls":"arrive_ApplyButtonBar__defaultControls","extraControls":"arrive_ApplyButtonBar__extraControls","darkMode":"arrive_ApplyButtonBar__darkMode","closeIcon":"arrive_ApplyButtonBar__closeIcon","mobileApplyBar":"arrive_ApplyButtonBar__mobileApplyBar","placeholderSpan":"arrive_ApplyButtonBar__placeholderSpan"};

function ApplyButtonBar(_ref) {
  var className = _ref.className,
      extraControls = _ref.extraControls,
      id = _ref.id,
      isApplyButtonDisabled = _ref.isApplyButtonDisabled,
      isClearButtonDisabled = _ref.isClearButtonDisabled,
      onApplyClick = _ref.onApplyClick,
      onClearClick = _ref.onClearClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'ethanol' : _ref$theme;

  var handleEnterPressClear = function handleEnterPressClear(evt) {
    evt.stopPropagation();

    if (evt.keyCode === 13) {
      onClearClick();
    }
  };

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](styles.applyButtonBar, className, _defineProperty({}, styles.darkMode, theme === "roadhog")),
    id: id
  }, /*#__PURE__*/React__default["default"].createElement("section", {
    className: styles.extraControls
  }, extraControls), /*#__PURE__*/React__default["default"].createElement("section", {
    className: styles.defaultControls
  }, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    disabled: isClearButtonDisabled,
    onClick: onClearClick,
    onKeyDown: handleEnterPressClear,
    text: true,
    type: "secondary"
  }, "Clear"), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    disabled: isApplyButtonDisabled,
    onClick: onApplyClick,
    type: "primary"
  }, "Apply")));
}
ApplyButtonBar.propTypes = {
  className: PropTypes__default["default"].string,
  extraControls: PropTypes__default["default"].element,
  id: PropTypes__default["default"].string,
  isApplyButtonDisabled: PropTypes__default["default"].bool,
  isCleaButtonDisabled: PropTypes__default["default"].bool,
  onApplyClick: PropTypes__default["default"].func.isRequired,
  onClearClick: PropTypes__default["default"].func.isRequired,
  theme: PropTypes__default["default"].oneOf(['ethanol', 'roadhog'])
};
ApplyButtonBar.defaultProps = {
  extraControls: null,
  isApplyButtonDisabled: false,
  isClearButtonDisabled: false
};
function ApplyButtonBarMobile(_ref2) {
  var className = _ref2.className,
      onApplyClick = _ref2.onApplyClick,
      onCancelClick = _ref2.onCancelClick,
      id = _ref2.id,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'ethanol' : _ref2$theme,
      title = _ref2.title;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](styles.mobileApplyBar, className, _defineProperty({}, styles.darkMode, theme === "roadhog")),
    id: id
  }, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    onClick: onCancelClick,
    text: true,
    type: "secondary"
  }, /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
    className: styles.closeIcon,
    svgRef: CLOSE__default["default"]
  })), /*#__PURE__*/React__default["default"].createElement("strong", null, title), onApplyClick ? /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    onClick: onApplyClick,
    text: true,
    type: "primary"
  }, "Apply") : /*#__PURE__*/React__default["default"].createElement("span", {
    className: styles.placeholderSpan
  }));
}
ApplyButtonBarMobile.propTypes = {
  className: PropTypes__default["default"].string,
  onApplyClick: PropTypes__default["default"].func,
  id: PropTypes__default["default"].string,
  onCancelClick: PropTypes__default["default"].func.isRequired,
  theme: PropTypes__default["default"].oneOf(['ethanol', 'roadhog']),
  title: PropTypes__default["default"].string
};

exports.ApplyButtonBarMobile = ApplyButtonBarMobile;
exports["default"] = ApplyButtonBar;
